import { render } from "./Components.vue?vue&type=template&id=f10ffcfe&scoped=true"
import script from "./Components.vue?vue&type=script&lang=js"
export * from "./Components.vue?vue&type=script&lang=js"

import "./Components.vue?vue&type=style&index=0&id=f10ffcfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10ffcfe"]])

export default __exports__